import { Boundaries } from "@planzone/core";
import { projectStatusCreationError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";

const initialState: State = [];

function handleRequest(
  state: State,
  { status }: Boundaries["editProjectStatus"]["request"],
): State {
  const index = state.findIndex((req) => req.status.uuid === status.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,

        {
          status,
          error: projectStatusCreationError,
          request: setRequestStateToPending(),
        },
      ];
}

function handleSuccess(
  state: State,
  { status }: Boundaries["editProjectStatus"]["success"],
): State {
  const index = state.findIndex((req) => req.status.uuid === status.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          status,
          error: projectStatusCreationError,
          request: setRequestStateToSuccess(),
        },
      ];
}

function handleFailure(
  state: State,
  { status, error }: Boundaries["editProjectStatus"]["failure"],
): State {
  const index = state.findIndex((req) => req.status.uuid === status.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], error, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          status,
          error,
          request: setRequestStateToFailure(),
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectStatusRequested]: handleRequest,
    [events.editProjectStatusSucceeded]: handleSuccess,
    [events.editProjectStatusFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
